
import { Button } from "@workspace/web-ui/components/button";
import { Separator } from "@workspace/web-ui/components/separator";
import { Fragment, useState } from "react";
import { PenLine, Plus } from "lucide-react";
import { Condition } from "../types";
import { useUpdateConditionModal } from "../store/condition-modal";
import { Modal } from "~/features/dashboard/components/modal";
import { ConditionForm } from "./forms/condition-form";

interface HealthConditionCardProps {
  items: Condition[];
  onButtonClick?: () => void;
}

const HealthConditionCard = ({ items, onButtonClick }: HealthConditionCardProps) => {
  const [selectedCondition, setSelectedCondition] = useState<Condition | null>(null);
  const { isOpen: isConditionModalOpen, open: openConditionModal, close: closeConditionModal } = useUpdateConditionModal()

  return (
    <div className="border rounded-xl shadow-sm bg-white w-full text-center mb-4 ">
      <header className="flex items-center justify-between p-5">
        <h3 className="text-lg font-medium text-[#1A202C]">Medical Conditions</h3>
        {onButtonClick && (
          <Button 
            variant="outline"
            className="px-4 bg-primary text-white py-1 rounded-lg"
            onClick={onButtonClick}
          >
            <Plus size={16} />
            Add
          </Button>
        )}
      </header>
      <Separator />
      <div className="space-y-4 p-5">
        <ul className=" grid sm:grid-cols-2 grid-cols-1 gap-2 align-top">
          {items.map((condition, index) => (
            <Fragment key={index}>
              <li
                key={index}
                className="p-4 rounded-md shadow-sm flex flex-col text-start bg-[#EBF0FB]"
              >
                <h3 className="text-base font-medium py-2">{condition.name}</h3>
                <p className="text-xs font-normal py-1">Diagnosed: {condition.date_diagnosed}</p>
                <ul>
                  {/* <li className="text-xs font-normal py-1"> {"\u2981"} {condition.description}</li> */}
                </ul>
                <Button 
                  onClick={() => { setSelectedCondition(condition); openConditionModal() }} 
                  variant="ghost" 
                  size="sm" 
                  className="gap-1 bg-white hover:bg-gray-100 border py-[10px] border-[#DCDCDE] rounded-lg text-sm w-full mt-2 flex items-center justify-center"
                >
                  <PenLine size={10} className="text-[#202020CC] text-xs" />
                  <span className="text-[#202020CC]">Edit</span>
                </Button>
              </li>
            </Fragment>
          ))}
        </ul>
      </div>
      {selectedCondition && (
        <Modal isOpen={isConditionModalOpen} onClose={closeConditionModal} title={"Update Conditions"}>
          <ConditionForm condition={selectedCondition} onClose={closeConditionModal} />
        </Modal>
      )}
    </div>
  );
};

export default HealthConditionCard;
